module.exports = __webpack_public_path__ + "static/media/4_diagram_1.2bf11954.svg";